import { Sparkles, Shield, TrendingUp, Store, Wallet, Navigation, UserPlus } from "lucide-react";
import { Button } from "@ui";
import { PALETTE, BG_PALETTE } from "../lib/theme";

const CTA_COLOR = PALETTE[5];
const CTA_BG = BG_PALETTE[5];

const ITEMS = [
  { Icon: Shield,     colorIdx: 0, titre: "Concurrence locale",                    desc: "L'analyse de vos futurs concurrents et les moyens pour vous différencier." },
  { Icon: TrendingUp, colorIdx: 1, titre: "Tendances actuelles",                   desc: "Les nouvelles tendances de consommation, à intégrer à votre projet." },
  { Icon: Store,      colorIdx: 2, titre: "Franchises adaptées",                   desc: "Correspondant à votre profil, à votre local, et qui souhaitent s'implanter ici." },
  { Icon: Wallet,     colorIdx: 3, titre: "Investissement initial et rentabilité", desc: "Plan de financement incluant les aides auxquelles vous êtes éligible." },
  { Icon: Navigation, colorIdx: 4, titre: "Optimisation de votre projet",          desc: "Synthèse de votre projet de départ avec des propositions d'optimisation." },
];

export function CtaCard() {
  return (
    <section
      className="mt-7 overflow-hidden rounded-2xl"
      style={{ boxShadow: "0 2px 16px rgba(127,119,221,0.13)" }}
    >
      <header
        className="px-4 pt-5 pb-4"
        style={{
          background: CTA_BG,
          borderBottom: `1.5px solid ${CTA_COLOR}22`,
        }}
      >
        <div className="mb-2.5 flex items-center gap-2">
          <div
            className="flex h-8 w-8 items-center justify-center rounded-md bg-white"
            style={{ boxShadow: `0 1px 4px ${CTA_COLOR}44` }}
          >
            <Sparkles size={16} color={CTA_COLOR} strokeWidth={2} />
          </div>
          <span
            className="text-[11px] font-bold uppercase tracking-widest"
            style={{ color: CTA_COLOR }}
          >
            Vous voulez ouvrir un commerce ?
          </span>
        </div>
        <h2 className="text-lg font-bold leading-snug text-slate-900">
          Décrivez votre projet pour générer une analyse 100% personnalisée
        </h2>
      </header>

      <div className="bg-white">
        {ITEMS.map((item, i) => {
          const Icon = item.Icon;
          return (
            <div
              key={`cta-${i}`}
              className="flex items-start gap-3 px-4 py-4"
              style={{
                borderBottom: i < ITEMS.length - 1 ? "1px solid #F2F4F8" : "none",
              }}
            >
              <div
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg"
                style={{ background: BG_PALETTE[item.colorIdx] }}
              >
                <Icon size={20} color={PALETTE[item.colorIdx]} strokeWidth={1.8} />
              </div>
              <div>
                <div className="text-sm font-bold text-slate-900">
                  {item.titre}
                </div>
                <div className="text-sm leading-relaxed text-slate-500">
                  {item.desc}
                </div>
              </div>
            </div>
          );
        })}
        <div className="px-4 pt-4 pb-5">
          <Button
            to="/inscription/candidat"
            target="_blank"
            size="lg"
            icon={UserPlus}
            className="w-full justify-center"
          >
            Décrire mon projet sur inSiti
          </Button>
          <p className="mt-2 flex items-center justify-center gap-2.5 text-xs text-slate-400">
            <span>✓ Gratuit</span>
            <span className="text-slate-200">·</span>
            <span>Résultat immédiat</span>
            <span className="text-slate-200">·</span>
            <span>100% sur-mesure</span>
          </p>
        </div>
      </div>
    </section>
  );
}
